import { FORM_FIELDS, FORM_FIELDS_NAMES, IFakeInputs } from '../new-application/new-application-form';

export const BANK_INFORMATION_FAKE_INPUTS = ({ t, data }): IFakeInputs[] => [
	{
		key: FORM_FIELDS.DDA_TYPE,
		label: t(FORM_FIELDS_NAMES.DDA_TYPE),
		value: data?.ddaType
	},
	{
		key: FORM_FIELDS.ACCOUNT_NUMBER,
		label: t(FORM_FIELDS_NAMES.ACCOUNT_NUMBER),
		value: data?.accountNumber
	},
	{
		key: FORM_FIELDS.ROUTING_NUMBER,
		label: t(FORM_FIELDS_NAMES.ROUTING_NUMBER),
		value: data?.routingNumber
	},
	{
		key: FORM_FIELDS.BANK_NAME,
		label: t(FORM_FIELDS_NAMES.BANK_NAME),
		value: data?.bankName
	}
];
